import { FC, ReactNode } from 'react';
import { Popover } from 'antd';
import styled from 'styled-components';

import { SvgIconName } from '~src/shared/SvgIcon';

import DdSelectorTrigger, { SelectedOption, DdSelectorTriggerProps } from './DdSelectorTrigger';

const DdContainer = styled.div`
  font-size: 1rem;
  color: ${({ theme }) => theme.baseBlue.a6};
  display: flex;
`;

interface OwnProps {
  popoverContent: ReactNode;
  isPopoverVisible: boolean;
  triggerLabelKey?: string;
  triggerCssClass?: string;
  triggerIconName?: SvgIconName;
  selectedOption?: SelectedOption | SelectedOption[];
  inactive?: boolean;
  inactiveKey?: string;
  blank?: boolean;
  maxWidth?: string;
  multiSelect?: boolean;
  togglePopover(visible: boolean): void;
}

export type DdPopoverSelectorProps = OwnProps & Pick<DdSelectorTriggerProps, 'resetSelected' | 'withReset'>;

const DdPopoverSelector: FC<DdPopoverSelectorProps> = (props) => {
  return (
    <DdContainer>
      <Popover
        trigger="click"
        open={props.isPopoverVisible}
        onOpenChange={props.togglePopover}
        content={props.popoverContent}
        placement="bottom"
        overlayClassName="dd-selector-popover"
      >
        {/* removing this div messes the dropdown so don't remove it */}
        <div>
          <DdSelectorTrigger
            isDdVisible={props.isPopoverVisible}
            selectedOption={props.selectedOption}
            cssClass={props.triggerCssClass}
            labelKey={props.triggerLabelKey}
            iconName={props.triggerIconName}
            inactive={props.inactive}
            inactiveKey={props.inactiveKey}
            blank={props.blank}
            maxWidth={props.maxWidth}
            multiSelect={props.multiSelect}
            withReset={props.withReset}
            resetSelected={props.resetSelected}
          />
        </div>
      </Popover>
    </DdContainer>
  );
};

export default DdPopoverSelector;
